export const addExternalLinkAriaLabels = ({
  externalLink = "external link",
  openInNewTab = "opens in a new tab",
  html = "",
}): string =>
  html.replaceAll(
    /<a\b([^>]*\btype=(?:"external"|'external')[^>]*)>([\s\S]*?)<\/a>/gi,
    (match, originalAttributes, linkInnerText) => {
      if (
        typeof originalAttributes === "string" &&
        typeof linkInnerText === "string"
      ) {
        if (/\baria-label\s*=\s*['"]/i.test(originalAttributes)) {
          return match;
        }

        // eslint-disable-next-line sonarjs/slow-regex -- this is Rich Text HTML content from the CMS. The next step is to sanitize it.
        const text = linkInnerText
          .replaceAll(/<[^>]*>/g, "")
          .replaceAll(/\s+/g, " ")
          .trim();
        if (!text) {
          return match;
        }

        const hasTargetBlank = /\btarget\s*=\s*['_"]_blank['_"]/i.test(
          originalAttributes,
        );

        const description = hasTargetBlank
          ? `${externalLink}, ${openInNewTab}`
          : externalLink;

        const aria = `${text} (${description})`;
        const safeAria = aria.replaceAll('"', "&quot;");

        const newAttributePart = `${originalAttributes} aria-label="${safeAria}"`;
        return `<a${newAttributePart}>${linkInnerText}</a>`;
      }

      return html;
    },
  );
